var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[(_vm.tokenUser!=null)?_c('Menu'):_vm._e(),_c('v-main',[_c('RouterView')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }